/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export default {
	position: 'absolute',
	top: '10%',
	left: '10%',
	mr: '10%',

	'.promo-large-text': {
		fontSize: '1.625rem',
		lineHeight: 1.4,
		fontWeight: 600,
		textShadow: '0 1px 0 rgba(255, 255, 255, 0.5)',
	},
} as SxProps;
